import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const CONVERTER_STUDY_CODE: {
  CONVERTER_STUDY_HAS_CHILD_ADAM: MvnCodeBE;
  CONVERTER_STUDY_ADAM_LIMIT_EXCEEDED: MvnCodeBE;
  CONVERTER_STUDY_COPY_ADAM_FORBIDDEN: MvnCodeBE;
} = {
  CONVERTER_STUDY_HAS_CHILD_ADAM: {
    status: 400,
    ko: "하위 ADaM Study가 있는 SDTM Study는 삭제할 수 없습니다.",
    en: "Cannot delete an SDTM study that has a child ADaM study.",
  },
  CONVERTER_STUDY_ADAM_LIMIT_EXCEEDED: {
    status: 400,
    ko: "ADaM Study는 SDTM Study당 최대 2개까지 생성할 수 있습니다.",
    en: "Cannot create more than 2 ADaM studies per SDTM study.",
  },
  CONVERTER_STUDY_COPY_ADAM_FORBIDDEN: {
    status: 400,
    ko: "ADaM Study는 복사할 수 없습니다.",
    en: "Cannot copy an ADaM study.",
  },
};

MvnCodeInitiate(CONVERTER_STUDY_CODE);
